<template>
  <div
    :class="loaded ? 'bg-truegray-100' : 'bg-truegray-500'"
    class="px-4 w-full min-h-screen"
  >
    <div class="mb-4 flex flex-wrap z-40 relative bg-white top-8 lg:top-0">
      <div class="w-full px-6 lg:p-16 flex flex-col justify-end items-center">
        <div
          class="w-full flex flex-wrap lg:flex-nowrap max-w-6xl items-center"
        >
          <div
            :class="
              cloudTenantLeaders.flagged_tenants.includes(author_id)
                ? 'contributor-badge-cw'
                : ''
            "
            class="h-24 w-24 flex items-center justify-center"
          >
            <div
              v-if="authorloaded"
              class="h-24 w-24 rounded-4xl bg-contain bg-center bg-no-repeat"
              :style="{ backgroundImage: `url(${current_author.logo})` }"
            ></div>
            <div v-else class="bg-truegray-900 h-24 w-24 rounded-4xl p-12 mb-8">
              <lottie :options="loadingAnimationOptions" />
            </div>

            <!-- check mark for tenant leader badge -->
            <div
              v-if="cloudTenantLeaders.flagged_tenants.includes(author_id)"
              :style="[{ top: '-1.2rem' }, { left: '4.1rem' }]"
              class="absolute h-12 w-12 p-1 rounded-full text-white"
            >
              <img
                src="/img/cloud_badges/badge_leader.png"
                alt="CareerWise tenant category leader badge"
              />
            </div>
          </div>

          <div v-if="loaded" class="flex flex-col justify-end pl-8">
            <p
              v-if="authorloaded && current_author.plan >= 2"
              class="mt-8 mb-2 uppercase text-sm font-semibold flex items-center text-cw-alt"
            >
              Careerwise School
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 relative bottom-1 ml-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M12 14l9-5-9-5-9 5 9 5z" />
                <path
                  d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
                />
              </svg>
            </p>
            <p
              v-else
              class="mt-8 mb-2 uppercase text-sm font-semibold flex items-center text-cw-700"
            >
              Careerwise Contributor
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 relative bottom-1 ml-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </p>
            <h1>
              <span v-if="authorloaded">{{ current_author.title }}</span>
              <span v-else>Loading...</span>
            </h1>
            <h6
              v-if="current_author.statistics && authorloaded"
              class="mb-8 pl-1"
            >
              Posts:
              <span class="text-cw-alt">{{
                current_author.statistics.posts
              }}</span>
              <span class="px-2">|</span>
              Shares:
              <span v-if="authorloaded" class="text-cw-alt">{{
                Number(current_author.statistics.shares).toLocaleString()
              }}</span>
              <span class="px-2">|</span>
              Total Reach:
              <span v-if="authorloaded" class="text-cw-alt">{{
                Number(current_author.statistics.audience).toLocaleString()
              }}</span>
            </h6>
          </div>
        </div>
        <!--
          <div class="mt-8 w-full flex justify-start items-center max-w-6xl">
          <PostsFilter :author="true" :parent="component_id" />
          </div> 
        -->
        <div class="absolute right-12 bottom-4 flex space-x-2 group">
          <div class="relative flex space-x-2">
            <img
              v-if="cloudTenantLeaders.share_avg[0] === author_id"
              class="h-12"
              src="/img/cloud_badges/badge_avg_gold.png"
              alt="CareerWise tenant category leader badge"
            />
            <img
              v-if="cloudTenantLeaders.share_avg[1] === author_id"
              class="h-12"
              src="/img/cloud_badges/badge_avg_silver.png"
              alt="CareerWise tenant category leader badge"
            />
            <img
              v-if="cloudTenantLeaders.share_avg[2] === author_id"
              class="h-12"
              src="/img/cloud_badges/badge_avg_bronze.png"
              alt="CareerWise tenant category leader badge"
            />

            <img
              v-if="cloudTenantLeaders.posts[0] === author_id"
              class="h-12"
              src="/img/cloud_badges/badge_posts_gold.png"
              alt="CareerWise tenant category leader badge"
            />
            <img
              v-if="cloudTenantLeaders.posts[1] === author_id"
              class="h-12"
              src="/img/cloud_badges/badge_posts_silver.png"
              alt="CareerWise tenant category leader badge"
            />
            <img
              v-if="cloudTenantLeaders.posts[2] === author_id"
              class="h-12"
              src="/img/cloud_badges/badge_posts_bronze.png"
              alt="CareerWise tenant category leader badge"
            />

            <img
              v-if="cloudTenantLeaders.shares[0] === author_id"
              class="h-12"
              src="/img/cloud_badges/badge_shares_gold.png"
              alt="CareerWise tenant category leader badge"
            />
            <img
              v-if="cloudTenantLeaders.shares[1] === author_id"
              class="h-12"
              src="/img/cloud_badges/badge_shares_silver.png"
              alt="CareerWise tenant category leader badge"
            />
            <img
              v-if="cloudTenantLeaders.shares[2] === author_id"
              class="h-12"
              src="/img/cloud_badges/badge_shares_bronze.png"
              alt="CareerWise tenant category leader badge"
            />
          </div>

          <!-- Tenant leader description -->
          <div
            v-if="cloudTenantLeaders.flagged_tenants.includes(author_id)"
            :style="[{ right: '120%' }, { width: '20rem' }]"
            class="z-50 absolute opacity-0 pointer-events-none group-hover:pointer-events-auto group-hover:opacity-100 top-0 bg-white rounded px-6 py-4 border border-truegray-300 text-black shadow"
          >
            <h3 class="mb-4 text-lg">
              CareerWise
              <span class="hotshot font-primary font-bold">Hotshot</span>
            </h3>
            <div class="flex flex-col space-y-4">
              <div
                v-if="cloudTenantLeaders.share_avg.includes(author_id)"
                class="flex items-center"
              >
                <div class="h-8 pr-4 flex-shrink-0">
                  <img
                    v-if="cloudTenantLeaders.share_avg[0] === author_id"
                    class="h-8"
                    src="/img/cloud_badges/badge_avg_gold.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="cloudTenantLeaders.share_avg[1] === author_id"
                    class="h-8"
                    src="/img/cloud_badges/badge_avg_silver.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="cloudTenantLeaders.share_avg[2] === author_id"
                    class="h-8"
                    src="/img/cloud_badges/badge_avg_bronze.png"
                    alt="CareerWise tenant category leader badge"
                  />
                </div>
                <div class="flex flex-col">
                  <h5 class="text-xs text-cw-alt uppercase">
                    Average Shares Leader
                  </h5>
                  <h5 class="text-xs italic">
                    This badge is awarded for being in the top 3 schools who
                    have the highest average shares per post recently.
                  </h5>
                </div>
              </div>

              <div
                v-if="cloudTenantLeaders.posts.includes(author_id)"
                class="flex items-center"
              >
                <div class="h-8 pr-4 flex-shrink-0">
                  <img
                    v-if="cloudTenantLeaders.posts[0] === author_id"
                    class="h-8"
                    src="/img/cloud_badges/badge_posts_gold.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="cloudTenantLeaders.posts[1] === author_id"
                    class="h-8"
                    src="/img/cloud_badges/badge_posts_silver.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="cloudTenantLeaders.posts[2] === author_id"
                    class="h-8"
                    src="/img/cloud_badges/badge_posts_bronze.png"
                    alt="CareerWise tenant category leader badge"
                  />
                </div>
                <div class="flex flex-col">
                  <h5 class="text-xs text-cw-alt uppercase">Post Leader</h5>
                  <h5 class="text-xs italic">
                    This badge is awarded for being in the top 3 schools who
                    have contributed the most posts into the Cloud recently.
                  </h5>
                </div>
              </div>

              <div
                v-if="cloudTenantLeaders.shares.includes(author_id)"
                class="flex items-center"
              >
                <div class="h-8 pr-4 flex-shrink-0">
                  <img
                    v-if="cloudTenantLeaders.shares[0] === author_id"
                    class="h-8"
                    src="/img/cloud_badges/badge_shares_gold.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="cloudTenantLeaders.shares[1] === author_id"
                    class="h-8"
                    src="/img/cloud_badges/badge_shares_silver.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="cloudTenantLeaders.shares[2] === author_id"
                    class="h-8"
                    src="/img/cloud_badges/badge_shares_bronze.png"
                    alt="CareerWise tenant category leader badge"
                  />
                </div>
                <div class="flex flex-col">
                  <h5 class="text-xs text-cw-alt uppercase">Shares Leader</h5>
                  <h5 class="text-xs italic">
                    This badge is awarded for being in the top 3 schools whose
                    cloud posts have been shared the most recently.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="posts"
      :class="[
        loaded && authorloaded
          ? 'bg-truegray-100 px-8 lg:px-16 py-16 lg:mb-4'
          : '',
        !loaded && authorloaded ? 'bg-truegray-500 mb-4' : '',
      ]"
      class="w-full flex flex-col items-center justify-center"
    >
      <div
        v-if="loaded && posts.length > 0"
        class="max-w-7xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-5 gap-4"
      >
        <PostsCard
          v-for="(post, i) in posts"
          :id="post.id"
          :key="i"
          :ref="'posts-' + i"
          :post="post"
          :cloud="true"
          :author_page="true"
        />
      </div>

      <div
        v-if="!loaded && authorloaded"
        class="h-52 mb-4 flex flex-col justify-center items-center"
      >
        <lottie :options="loadingAnimationOptions" />
        <span class="text-white text-center">Loading posts</span>
      </div>

      <p v-if="loaded && posts.length < 1" class="text-md">
        We could not find any posts...
      </p>

      <!-- PAGINATION -->
      <div
        v-if="pagination.previouspage || pagination.nextpage"
        class="flex justify-between items-center mt-8 h-10"
      >
        <span
          :disabled="!pagination.previouspage"
          :class="[
            !pagination.previouspage
              ? 'opacity-25 cursor-not-allowed'
              : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
          ]"
          class="text-gray-500"
          @click="getPosts(pagination.previouspage)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 17l-5-5m0 0l5-5m-5 5h12"
            />
          </svg>
        </span>
        <span class="text-center text-xs"
          >Page {{ pagination.current_page }} of
          {{ pagination.total_pages }}</span
        >
        <span
          :disabled="!pagination.nextpage"
          :class="[
            !pagination.nextpage
              ? 'opacity-25 cursor-not-allowed'
              : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
          ]"
          class="text-gray-500"
          @click="getPosts(pagination.nextpage)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </span>
      </div>
    </div>

    <!-- /Posts -->
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'
import PostsFilter from '../components/PostsFilter.vue'
import PostsCard from '../../../shared/components/PostsCard.vue'
import * as loadingAnimation from '../../../shared/components/loading.json'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    PostsFilter,
    PostsCard,
  },

  mixins: [shared],

  props: {
    author_id: {
      type: Number,
      required: false,
      default: 0,
    },

    tenant: { default: false },
  },

  data() {
    return {
      component_id: false,

      authorloaded: false,
      loaded: false,

      auther_type: false,

      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,
      posts: [],
      current_author: {},
      fromPostCount: 0,

      filter_type: false,
      filter_option: false,

      stats_leaders: {},

      window: { width: 0, height: 0 },
      inputClass:
        'flex justify-center items-center sm:text-sm text-black focus:text-black active:text-black focus:outline-none active:outline-none transition-all duration-100 ease-in-out rounded bg-white px-4 h-12',

      pagination: {
        current_page: null,
        total_pages: null,
        per_page: 9,
        next_page: null,
        previous_page: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null,
        nextpage: null,
        previouspage: null,
      },
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      cloudTenantLeaders: 'careerwise/getCloudTenantLeaders',
    }),
  },

  watch: {
    current_author: {
      handler: function (author) {
        if (author.plan) {
          if (author.plan >= 2) {
            this.$set(this, 'auther_type', 'school')
          } else {
            this.$set(this, 'auther_type', 'contributor')
          }
        }
      },

      deep: true,
    },

    stats_leaders: {
      handler: function (val) {
        let post_leaders_arr = val.posts.slice(0, 3)
        let final_post_leaders_arr = post_leaders_arr.map((obj) => {
          return obj.tenant_id
        })

        let share_leaders_arr = val.shares.slice(0, 3)
        let final_share_leaders_arr = share_leaders_arr.map((obj) => {
          return obj.tenant_id
        })

        let share_avg_leaders_arr = val.share_avg.slice(0, 3)
        let final_share_avg_leaders_arr = share_avg_leaders_arr.map((obj) => {
          return obj.tenant_id
        })

        let store_leaders = {
          posts: final_post_leaders_arr,
          shares: final_share_leaders_arr,
          share_avg: final_share_avg_leaders_arr,
          flagged_tenants: [
            ...final_post_leaders_arr,
            ...final_share_leaders_arr,
            ...final_share_avg_leaders_arr,
          ],
        }

        this.dispatchSetCloudTenantLeaders(store_leaders)
      },

      deep: true,
    },

    posts: {
      handler: function () {
        this.setTags()
      },

      deep: true,
    },
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  mounted() {
    this.getAuthor(this.author_id)

    this.$set(this, 'component_id', this.makeId())

    this.getCloudCategoryLeaders()

    EventBus.$on('getCloudPostsWithFilterOptions', (data) => {
      if (data.parent === this.component_id) {
        this.getPosts()
      }
    })
  },

  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    ...mapActions({
      dispatchSetCloudTenantLeaders: 'careerwise/dispatchSetCloudTenantLeaders',
    }),

    getAuthor(id) {
      if (this.tenant) {
        axios.get('/api/cloud-tenant/' + id).then((response) => {
          let result = response.data
          if (result.success) {
            if (result.author.length > 0) {
              this.$set(this, 'current_author', result.author[0])
              this.getPosts()
            }
            this.$set(this, 'authorloaded', true)
          }
          if (result?.alert) {
            EventBus.$emit('triggerAlertResponse', result.alert)
          }
        })
      } else {
        axios.get('/api/cloud-author/' + id).then((response) => {
          let result = response.data
          if (result.success) {
            if (result.author.length > 0) {
              this.$set(this, 'current_author', result.author[0])
              this.getPosts()
            }
            this.$set(this, 'authorloaded', true)
          }
        })
      }
    },

    getCloudCategoryLeaders() {
      axios.get('/api/cloud-badge-leaders').then((response) => {
        let result = response.data
        if (result.success) {
          this.$set(this, 'stats_leaders', result.leaders)
        }
      })
    },

    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },

    resetFilters() {
      EventBus.$emit('resetFilters')
    },

    setTags() {
      if (this.posts.length > 0) {
        this.posts.forEach((post) => {
          //general tags
          if (this.settings.tags && this.settings.tags.length > 0) {
            let general_arr = []
            this.settings.tags.forEach((i) => {
              if (post.tag_titles.includes(i.text)) {
                general_arr.push(i.text)
              }
            })
            post.general_tags = general_arr
          }

          // Year tags
          if (this.settings.tag_years && this.settings.tag_years.length > 0) {
            let year_arr = []
            this.settings.tag_years.forEach((i) => {
              if (post.tag_titles.includes(i.text)) {
                year_arr.push(i.text)
              }
            })
            post.year_tag = year_arr
          }

          // Region tags
          if (
            this.settings.tag_regions &&
            this.settings.tag_regions.length > 0
          ) {
            let region_arr = []
            this.settings.tag_regions.forEach((i) => {
              if (post.tag_titles.includes(i.text)) {
                region_arr.push(i.text)
              }
            })
            post.region_tag = region_arr
          }
        })
      }
    },

    /**
        ============================ GET POSTS WITH FILTER OPTION ===============
      */
    getPosts(gotopage = null) {
      // If already loaded, assume we are searching or paginating, scroll to posts
      let scrollToPosts = false
      if (this.loaded) {
        scrollToPosts = true
      }

      let submitData = {}

      if (this.author_id) {
        submitData.author = this.author_id
      }
      if (this.tenant) {
        submitData.author_is_school = true
      }
      // Pagination page?
      if (gotopage) {
        submitData.page = gotopage
      }

      // Get this post...
      axios.post('/api/cloud-author-posts', submitData).then((response) => {
        let result = response.data
        if (result.success) {
          this.$set(this, 'posts', result.posts)
          this.$set(this, 'loaded', true)

          // pagination.total = total # of posts. / by per_page, + 1. Pagination doesnt show when not needed so +1 is never wrong on single page
          let total_pages =
            Math.floor(
              response.data.pagination.total /
                response.data.pagination.per_page,
            ) + 1
          this.$set(
            this.pagination,
            'current_page',
            response.data.pagination.current_page,
          )
          this.$set(this.pagination, 'total_pages', total_pages)
          this.$set(
            this.pagination,
            'per_page',
            response.data.pagination.per_page,
          )
          this.$set(
            this.pagination,
            'last_page_url',
            response.data.pagination.last_page_url,
          )
          this.$set(
            this.pagination,
            'next_page_url',
            response.data.pagination.next_page_url,
          )
          this.$set(
            this.pagination,
            'prev_page_url',
            response.data.pagination.prev_page_url,
          )
          this.$set(
            this.pagination,
            'path',
            response.data.pagination.next_page_path,
          )

          let prev = null
          if (this.pagination.prev_page_url) {
            prev = this.pagination.prev_page_url.split('=')
            prev = prev[1]
          }

          let next = null
          if (this.pagination.next_page_url) {
            next = this.pagination.next_page_url.split('=')
            next = next[1]
          }

          this.$set(this.pagination, 'previouspage', prev)
          this.$set(this.pagination, 'nextpage', next)

          // Scroll to posts on pagination and search click
          if (scrollToPosts) {
            this.$scrollTo('#posts')
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.contributor-badge-cw::before {
  top: -18px;
  left: -18px;
  right: -18px;
  bottom: -18px;
  border-radius: 200px;
  border: 5px solid transparent;
}

.hotshot {
  background: -webkit-linear-gradient(45deg, var(--cw-700), var(--cw-alt));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
</style>
